import AuthDialogLayout from "components/Layout/AuthDialogLayout";
import useDialog from "hooks/useDialog";
import { useMediaQuery } from "react-responsive";
import Signup from "components/Signup/Signup";

const SignUpDialong = () => {
  const { isSignupDialogOpen, closeSignupDialog } = useDialog();

  const isMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  return (
    <AuthDialogLayout
      isDialogOpen={isSignupDialogOpen}
      closeDialog={closeSignupDialog}
      isCopyrightHide={isMobile}
    >
      <div className="2xl:mt-[56px] lg:mt-10">
        <Signup />
      </div>
    </AuthDialogLayout>
  );
};

export default SignUpDialong;
